import {
  AfterViewInit,
  ChangeDetectorRef,
  Component,
  ElementRef,
  EventEmitter,
  Inject,
  Input,
  OnDestroy,
  OnInit,
  Output,
  ViewChild,
} from '@angular/core';
import {
  MAT_DIALOG_DATA,
  MatDialog,
  MatDialogConfig,
  MatDialogRef,
} from '@angular/material/dialog';
import { MatAccordion } from '@angular/material/expansion';
import { TaskService } from '../../../../core/timeline';
import { CreateTaskComponent } from '../../calendar/create-task/create-task.component';
import { LayoutUtilsService, MessageType } from '../../../../core/_base/crud';
import { FormControl, FormGroup } from '@angular/forms';
import { currentUser, User } from '../../../../core/auth';
import { select, Store } from '@ngrx/store';
import { AppState } from '../../../../core/reducers';
import { debounceTime, distinctUntilChanged, take, tap } from 'rxjs/operators';
import { forkJoin, of, Subscription } from 'rxjs';
import { CommentsDialogComponent } from '../../../partials/content/general/comments-dialog/comments-dialog.component';
import { GlobalSettingsService } from '../../../../core/services/global-settings.service';
import { MatPaginator, PageEvent } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { StringUtilsService } from '../../../../core/services/string-utils.service';
import { ActivatedRoute, Params } from '@angular/router';
import { ChooseTemplateDialogComponent } from '../../calendar/choose-template/choose-template.dialog.component';
import { FollowUpService } from '../../../../core/services/follow-up.service';
import { ConfirmActionDialogComponent } from '../../../partials/content/crud';
import { Blocker } from '../../../../core/models';
import { TaskMode, TaskStatus } from '../../calendar/enums';
import { FilterFormValue, TaskFilterService } from '../task-filter-utility.service';
import { NgxPermissionsService } from 'ngx-permissions';
import { TaskStateService } from 'src/app/core/_base/layout/services/task-state.service';
import {
  FeatureFlag,
  FeatureFlagService,
} from 'src/app/core/services/feature-flags/feature-flag.service';
import { TaskSkeletonComponent } from '../../calendar/task-skeleton/task-skeleton.component';

@Component({
  selector: 'kt-task-list',
  templateUrl: './task-list.component.html',
  styleUrls: ['./task-list.component.scss'],
})
export class TaskListComponent implements OnInit, AfterViewInit, OnDestroy {
  @ViewChild(MatAccordion) accordion: MatAccordion;
  @ViewChild('sort1', { static: true }) sort: MatSort;
  @ViewChild(MatPaginator, { static: true }) paginator: MatPaginator;
  userIdFilter: any;
  @Input() teamId;
  @Input() template_id;
  @Input() tagId;
  @Input() categoryName;
  @Input() canvasShow;
  @ViewChild('searchInput', { static: true }) searchInput: ElementRef;
  entitiesMap = new Map();
  searchForm: FormGroup;
  taskList = [];
  subtaskList = [];
  openTaskLength = 0;
  completedTaskLength = 0;
  loading = false;
  subtaskLoading = false;
  totalNumber = 0;
  categoryId = [];
  priority: any;
  sortTask = 'dueDate';
  sortDirection = 'asc';
  userIds = '';
  officeId: any;
  entityIds: any;
  parentId = '';
  size = 10;
  page = 0;
  isCompleted: any = '';
  entitiesIds = [];
  usersIds = [];
  entitiesGroupObj;
  usersObj = [];
  progress = [];
  done = [];
  cancelled = [];
  locked = false;
  private subscriptions: Subscription[] = [];
  private user: any;
  @Input() filteredView;
  @Input() EntitiesFilteredBy;
  @Output() totalCount = new EventEmitter<any>();
  @Input() inputTasks;
  @Input() groupedByTeam;
  @Input() groupedByTemplate;
  @Input() groupedByTag;
  @Input() groupedByPatient;
  @Input() fromPatient;
  @Input() fromDoctor;
  @Input() patient_id_for_task_list;
  @Input() doctor_id_for_task_list;
  @Input() fromGroupBy;
  cancelledTaskLength = 0;
  isCanceled: any;
  private usersChangedFirstTime = true;
  currentUser: User;
  private templateIds: any;
  private tagIds: any;
  search: FormControl;
  fromDateCreated: any;
  toDateCreated: any;
  toDateDue: any;
  fromDateDue: any;
  isFollowing = false;
  isNotAssigned = false;
  isMyTasks;
  openedTab = 'OPEN';
  sortSelected = false;
  withFollowup: boolean;
  showAddBar = false;
  showGroupTeam = false;
  filterStatus = '';
  patientId;
  doctorId;
  filterFormValue: FilterFormValue;
  enableAsyncTaskDetailsLoading: boolean;
  constructor(
    private store: Store<AppState>,
    private taskService: TaskService,
    private taskStateService: TaskStateService,
    private globalSettingsService: GlobalSettingsService,
    private cdr: ChangeDetectorRef,
    public dialog: MatDialog,
    private layoutUtilsService: LayoutUtilsService,
    public stringUtils: StringUtilsService,
    private activatedRoute: ActivatedRoute,
    private followUpService: FollowUpService,
    private taskFilterService: TaskFilterService,
    private permissionsService: NgxPermissionsService,
    private featureFlagService: FeatureFlagService,
  ) {
    this.search = new FormControl('');
    if (this.userIdFilter) {
      this.taskFilterService.myTasks.next(false);
    }
  }

  ngOnInit(): void {
    this.checkAsyncTaskDetailsLoadingFlag();
    if (
      this.activatedRoute.url[`_value`][0] &&
      this.activatedRoute.url[`_value`][0].path === 'list'
    ) {
      this.showAddBar = true;
      this.showGroupTeam = true;
      this.groupedByTeam = false;
      this.groupedByTemplate = false;
      this.groupedByTag = false;
      this.groupedByPatient = false;
    }
    if (
      this.taskFilterService.fromDashboard.value === false &&
      !this.taskFilterService.backFromGroupByView.value &&
      !this.fromGroupBy
    ) {
      this.taskFilterService.updateMyTaskStatus(false);
      this.taskFilterService.updateFilterObject(this.taskFilterService.initialFormValue);
    }
    if (this.taskFilterService.backFromGroupByView.value) {
      this.taskFilterService.backFromGroupByView.next(false);
    }
    if (this.filteredView) {
      this.showGroupTeam = true;
    }
    if (this.fromPatient) {
      this.activatedRoute.params.subscribe((params: Params) => {
        if (!params.id && !this.patient_id_for_task_list) {
          this.entityIds = -1;
        } else if (params.id || this.patient_id_for_task_list) {
          this.patientId = this.patient_id_for_task_list
            ? this.patient_id_for_task_list
            : params.id;
          this.entityIds = this.patientId;
        }
      });
    }
    if (this.fromDoctor) {
      this.activatedRoute.params.subscribe((params) => {
        this.doctorId = this.doctor_id_for_task_list ? this.doctor_id_for_task_list : params.id;
        this.entityIds = this.doctorId;
      });
    }
    const userSubscription = this.store.pipe(select(currentUser), take(1)).subscribe((res) => {
      this.user = res;
    });
    this.subscriptions.push(userSubscription);
    const myTaskSubscription = this.taskFilterService.myTasks.subscribe((val) => {
      this.isMyTasks = val;
    });
    this.subscriptions.push(myTaskSubscription);
    const userFilter = this.taskService.userIdFilter.subscribe((object) => {
      this.userIdFilter = object;
      this.loadTasks(this.isCompleted, this.isCanceled);
    });
    this.subscriptions.push(userFilter);

    this.search.valueChanges
      .pipe(
        debounceTime(600),
        distinctUntilChanged(),
        tap(() => {
          this.paginator.pageIndex = 0;
          this.loadTasks(this.isCompleted, this.isCanceled);
        }),
      )
      .subscribe();

    this.globalSettingsService.$loadTaskList.subscribe((res) => {
      if (res) {
        this.loadTasks(this.isCompleted, this.isCanceled);
      }
    });
    const filterButtonValue = this.taskFilterService.filterFormSubject.subscribe((formValue) => {
      this.categoryId = [];
      // replace and use only ID
      this.filterFormValue = formValue;
      // DATES
      this.withFollowup = formValue?.withFollowUp;
      this.toDateDue = formValue.dueDate?.toDateDue;
      this.fromDateDue = formValue.dueDate?.fromDateDue;
      this.fromDateCreated = formValue.createdDate?.fromDateCreated;
      this.toDateCreated = formValue.createdDate?.toDateCreated;

      // USERS
      if (this.usersChangedFirstTime) {
        this.usersChangedFirstTime = false;
      }
      this.userIds = formValue.user ? formValue.user.id : '';
      this.isNotAssigned = false;

      this.entityIds = formValue.entity
        ? formValue.entity.id
        : this.fromPatient || this.fromDoctor
        ? this.entityIds
        : null;

      // TEAMS
      if (formValue.team.length > 0) {
        const teamIds = formValue.team.map((team) => team.id);
        if (teamIds[0] === 0) {
          this.categoryId = ['without'];
        } else {
          this.categoryId = teamIds;
        }
      } else {
        this.categoryId = [];
      }

      this.templateIds = formValue.template ? formValue.template.id : '';
      this.tagIds = formValue.tag ? formValue.tag.id : '';
      this.priority = formValue.priority;
      this.filterStatus = formValue.status;
      this.officeId = formValue.office ? formValue.office.id : '';

      this.resetPagination(this.openedTab);
      this.loadTasks(this.isCompleted, this.isCanceled);
    });
    this.subscriptions.push(filterButtonValue);
    this.taskService.getRefresh().subscribe(() => {
      if (this.userIdFilter) {
        this.isNotAssigned = false;
        this.taskFilterService.updateMyTaskStatus(false);
        this.userIds = '';
        return;
      }
      // commented out as it gives too many uncessary calls (for the time being 13-09)
      this.loadTasks(this.isCompleted, this.isCanceled);
    });
  }

  ngAfterViewInit(): void {
    if (this.user && this.userIds && !this.filteredView) {
      this.usersChangedFirstTime = false;
    }
  }

  ngOnDestroy() {
    this.subscriptions.forEach((subscription) => subscription.unsubscribe());
  }

  getQueryParams(category: string) {
    if (this.filteredView && this.EntitiesFilteredBy) {
      return {
        category,
        ids: this.EntitiesFilteredBy.join(','),
        filteredView: this.filteredView,
      };
    }
    return { category };
  }

  loadTasks(isCompleted, isCanceled, ignoreLoadCounts = false) {
    if (!ignoreLoadCounts) {
      this.loadTasksCounts(isCompleted, isCanceled);
    }
    if (isCanceled) {
      this.filterStatus = 'CANCELED';
    }
    if (isCompleted) {
      this.filterStatus = 'DONE';
    }
    if (this.openedTab === 'OPEN') {
      this.filterStatus = this.taskFilterService.filterFormSubject.value.status;
    }
    this.loading = true;
    this.taskList = [];
    this.isCanceled = isCanceled;
    this.isCompleted = isCompleted;
    // for focused view dashboard
    if (this.filteredView && this.EntitiesFilteredBy) {
      // tslint:disable-next-line:max-line-length

      const taskSubscriptionFiltered = this.taskService
        .getTasksInFilteredView(
          isCompleted,
          isCanceled,
          this.page,
          this.size,
          this.parentId,
          [this.entityIds],
          (this.groupedByTemplate || this.groupedByTeam || this.groupedByTag || this.fromPatient) &&
            this.userIdFilter
            ? this.userIdFilter.id
            : this.userIds,
          this.groupedByTeam ? [this.teamId] : this.categoryId,
          this.EntitiesFilteredBy,
          this.groupedByTemplate ? this.template_id : this.templateIds,
          this.groupedByTag ? this.tagId : this.tagIds,
          this.priority,
          this.toDateCreated,
          this.fromDateCreated,
          this.toDateDue,
          this.fromDateDue,
          this.isFollowing,
          this.isNotAssigned,
          this.search.value,
          this.filterStatus,
          this.officeId,
        )
        .pipe(take(1))
        .subscribe((res) => {
          this.taskList = res.data;
          this.getAllEntitiesAndUsers(res.data);
          this.totalNumber = res.count;
          // this.isCompleted = isCompleted
          this.loading = false;
          this.cdr.detectChanges();
        });
      this.subscriptions.push(taskSubscriptionFiltered);
      return;
    }
    // for general search dashboard
    if (this.inputTasks) {
      this.progress = this.inputTasks.filter(
        (e) => e.progress !== 'DONE' && e.progress !== 'CANCELED',
      );
      this.done = this.inputTasks.filter((e) => e.progress === 'DONE');
      this.cancelled = this.inputTasks.filter((e) => e.progress === 'CANCELED');
      let openTasks = this.progress;

      if (this.openedTab === 'OPEN') {
        openTasks = this.progress;
      }
      if (this.openedTab === 'COMPLETED') {
        openTasks = this.done;
      }
      if (this.openedTab === 'CANCELED') {
        openTasks = this.cancelled;
      }
      this.taskList = openTasks;
      this.getAllEntitiesAndUsers(openTasks);
      this.openTaskLength = this.progress.length;
      this.completedTaskLength = this.done.length;
      this.cancelledTaskLength = this.cancelled.length;
      this.totalCount.emit(this.openTaskLength);
      return;
    }
    if (this.isMyTasks) {
      this.userIdFilter = undefined;
      this.isNotAssigned = false;
      this.userIds = '' + this.user.id;
    }
    // for normal case ( task list component )
    this.taskService
      .getTasks(
        this.page,
        this.size,
        this.parentId,
        [this.entityIds],
        (this.groupedByTemplate || this.groupedByTeam || this.groupedByTag || this.fromPatient) &&
          this.userIdFilter
          ? this.userIdFilter.id
          : this.userIds,
        this.groupedByTeam ? [this.teamId] : this.categoryId,
        this.groupedByTemplate ? this.template_id : this.templateIds,
        this.groupedByTag ? this.tagId : this.tagIds,
        this.priority,
        this.toDateCreated,
        this.fromDateCreated,
        this.toDateDue,
        this.fromDateDue,
        this.isFollowing,
        this.isNotAssigned,
        this.sortTask,
        this.sortDirection,
        this.search.value,
        this.withFollowup,
        this.filterStatus,
        this.officeId,
      )
      .pipe(take(1))
      .subscribe((res) => {
        this.taskList = res.data;
        this.getAllEntitiesAndUsers(res.data);
        this.totalNumber = res.count;
        this.loading = false;
        this.cdr.detectChanges();
      });
  }

  getAllEntitiesAndUsers(data) {
    for (const row of data) {
      row.task_responsible_users.forEach((element) => this.usersIds.push(element.responsible_id));
      row.task_entities.forEach((element) => this.entitiesIds.push(element.entity_id));
    }
    forkJoin({
      requestOne:
        this.entitiesIds.length > 0 ? this.taskService.getEntities(this.entitiesIds) : of([]),
      requestTwo: this.usersIds.length > 0 ? this.taskService.getUsersbyId(this.usersIds) : of([]),
    })
      .pipe(take(1))
      .subscribe(({ requestOne, requestTwo }) => {
        if (requestOne.data) {
          this.entitiesGroupObj = this.groupBy(requestOne.data, (pet) => pet.entity_type);
          this.cdr.detectChanges();
        }
        if (requestTwo.pageOfItems) {
          this.usersObj = [];
          this.usersObj = requestTwo.pageOfItems;
          this.cdr.detectChanges();
        }
      });
  }

  groupBy(list, keyGetter) {
    const map = new Map();
    list.forEach((item) => {
      const key = keyGetter(item);
      const collection = map.get(key);
      if (!collection) {
        map.set(key, [item]);
      } else {
        collection.push(item);
      }
    });
    return map;
  }

  updateCompleted(task): void {
    this.taskService
      .getTaskV3(task.id)
      .pipe(take(1))
      .subscribe((res1) => {
        if (!res1?.data) return;

        const dialogRef =
          task.progress === TaskStatus.DONE
            ? this.dialog.open(UpdateProgressComponent, { width: '250px' })
            : this.layoutUtilsService.confirmAction(
                'Update Task',
                'Are you sure you want to set the status of this task active step to "Done"?',
                'Updating...',
              );

        dialogRef
          .afterClosed()
          .pipe(take(1))
          .subscribe((res2) => {
            if (!res2) return;

            res1.data.steps = res1.data.steps.map((s) => {
              s.progress =
                s.id === task.current_step_id
                  ? task.progress === TaskStatus.DONE
                    ? res2
                    : TaskStatus.DONE
                  : s.progress;

              return s;
            });

            this.taskService
              .updateTaskV3Step(task.current_step_id, res1.data)
              .pipe(take(1))
              .subscribe(
                () => {
                  this.loadTasks(this.isCompleted, this.isCanceled);
                },
                (err) => {
                  this.layoutUtilsService.showActionNotification(
                    err?.error?.errors[0]?.details,
                    MessageType.Update,
                    3000,
                    false,
                    false,
                  );
                },
              );
          });
      });
  }

  checkDateRectangle(firstDate) {
    const today = new Date();
    firstDate = new Date(firstDate);
    if (today.setHours(0, 0, 0, 0) === firstDate.setHours(0, 0, 0, 0)) {
      return 'TD';
    }
    if (this.getDifferenceInDays(firstDate, today) === 1 && today < firstDate) {
      return 'TM';
    }
    if (this.getDifferenceInDays(firstDate, today) > 0 && today > firstDate) {
      return 'OD';
    }
    return null;
  }

  checkDateRectangleStyle(firstDate) {
    const today = new Date();
    firstDate = new Date(firstDate);
    if (today.setHours(0, 0, 0, 0) === firstDate.setHours(0, 0, 0, 0)) {
      return 'warning';
    }
    if (this.getDifferenceInDays(firstDate, today) > 0 && today > firstDate) {
      return 'red';
    }
    return 'secondary';
  }

  numberOfDaysCreated(task) {
    const today = new Date();
    let created = task.created;
    created = new Date(created);
    if (this.isCompleted) {
      let completed = task.completed_at;
      completed = new Date(completed);
      return this.getDifferenceInDays(created, completed);
    }
    return this.getDifferenceInDays(created, today);
  }

  getDifferenceInDays(date1, date2) {
    const diff = Math.abs(date1.getTime() - date2.getTime());
    return Math.ceil(diff / (1000 * 3600 * 24));
  }

  updateTask(task): void {
    this.updateTaskWithPreDialog(task);
  }
  private checkAsyncTaskDetailsLoadingFlag(): void {
    this.featureFlagService
      .getFlagValue(FeatureFlag.ENABLE_ASYNC_TASK_DETAILS_LOADING)
      .subscribe((asyncTaskDetailsLoadingEnabled) => {
        if (asyncTaskDetailsLoadingEnabled !== null) {
          this.enableAsyncTaskDetailsLoading = asyncTaskDetailsLoadingEnabled;
        } else {
          this.enableAsyncTaskDetailsLoading = false;
        }
      });
  }
  updateTaskWithPreDialog(task): void {
    // 1) open skeleton dialog
    const loadingRef = this.dialog.open(TaskSkeletonComponent, {
      width: '95vw',
      maxWidth: '95vw',
      disableClose: true,
      closeOnNavigation: true,
      panelClass: 'no-padding-dialog', // optional
    });

    // 2) load the task
    this.taskService
      .getTaskV3(task.id)
      .pipe(take(1))
      .subscribe({
        next: (res1) => {
          if (!res1?.data) {
            loadingRef.close();
            this.layoutUtilsService.showActionNotification(
              'Unable to load task.',
              MessageType.Update,
              3000,
              false,
              false,
            );
            return;
          }

          if (res1.data.lock) {
            loadingRef.close();
            const message = 'This task is locked by ' + res1.data.locked_by;
            this.layoutUtilsService.showActionNotification(
              message,
              MessageType.Update,
              3000,
              false,
              false,
            );
            return;
          }

          // try to lock
          this.taskService
            .updateTaskLock(task.id, { lock: true })
            .pipe(take(1))
            .subscribe({
              next: (res2) => {
                loadingRef.close(); // 3) close the skeleton

                if (!res2?.ok) {
                  this.layoutUtilsService.showActionNotification(
                    'Failed to lock task.',
                    MessageType.Update,
                    3000,
                    false,
                    false,
                  );
                  return;
                }

                task.lock = true;

                // 4) open the real dialog the "old way" (no internal skeleton)
                const dialogRef = this.dialog.open(CreateTaskComponent, {
                  width: '95vw',
                  maxWidth: '95vw',
                  disableClose: true,
                  closeOnNavigation: true,
                  data: {
                    mode: this.permissionsService.getPermission('canEditTask')
                      ? TaskMode.UPDATE
                      : TaskMode.VIEW,
                    task: res1.data,
                  },
                });

                dialogRef
                  .afterClosed()
                  .pipe(take(1))
                  .subscribe((data) => {
                    this.taskService
                      .updateTaskLock(task.id, { lock: false })
                      .pipe(take(1))
                      .subscribe((res3) => {
                        if (res3?.ok) task.lock = false;
                        if (data) this.loadTasks(this.isCompleted, this.isCanceled);
                      });
                  });
              },
              error: () => {
                loadingRef.close();
                this.layoutUtilsService.showActionNotification(
                  'Failed to lock task.',
                  MessageType.Update,
                  3000,
                  false,
                  false,
                );
              },
            });
        },
        error: () => {
          loadingRef.close();
          this.layoutUtilsService.showActionNotification(
            'Unable to load task.',
            MessageType.Update,
            3000,
            false,
            false,
          );
        },
      });
  }
  

  updateTaskSync(task): void {
    this.taskService
      .getTaskV3(task.id)
      .pipe(take(1))
      .subscribe((res1) => {
        if (!res1?.data) return;

        if (res1.data.lock) {
          const message = 'This task is locked by ' + res1.data.locked_by;

          this.layoutUtilsService.showActionNotification(
            message,
            MessageType.Update,
            3000,
            false,
            false,
          );
          return;
        }

        this.taskService
          .updateTaskLock(task.id, { lock: true })
          .pipe(take(1))
          .subscribe((res2) => {
            if (!res2?.ok) return;

            task.lock = true;

            const dialogConfig = new MatDialogConfig();

            dialogConfig.disableClose = true;
            dialogConfig.closeOnNavigation = true;
            dialogConfig.width = '95vw';
            dialogConfig.maxWidth = '95vw';
            dialogConfig.data = {
              mode: this.permissionsService.getPermission('canEditTask')
                ? TaskMode.UPDATE
                : TaskMode.VIEW,
              task: res1.data,
            };

            const dialogRef = this.dialog.open(CreateTaskComponent, dialogConfig);

            dialogRef
              .afterClosed()
              .pipe(take(1))
              .subscribe((data) => {
                this.taskService
                  .updateTaskLock(task.id, { lock: false })
                  .pipe(take(1))
                  .subscribe((res3) => {
                    if (res3?.ok) task.lock = false;
                    if (data) this.loadTasks(this.isCompleted, this.isCanceled);
                  });
              });
          });
      });
  }

  loadPage($event: PageEvent) {
    this.page = $event.pageIndex;
    this.size = $event.pageSize;
    this.loadTasks(this.isCompleted, this.isCanceled, true);
  }

  getFullNameList(user) {
    const res = '';
    if (!user) {
      return res;
    } else {
      const u = this.usersObj.find((e) => e.id === user.responsible_id);
      if (u) {
        return '' + u.userName;
      }
      return res;
    }
  }

  mapArray(entities, type) {
    const res = [];
    if (!this.entitiesGroupObj) return res;
    if (!entities) {
      return res;
    } else {
      entities.forEach((item) => {
        if (!this.entitiesGroupObj.has(type)) return;
        const entity = this.entitiesGroupObj.get(type).find((e) => e.id === item.entity_id);
        if (entity) {
          res.push(entity);
        }
      });
      return res;
    }
  }

  mapObe(entity, type) {
    const res = [];
    if (!entity) {
      return res;
    }
    return this.entitiesGroupObj
      ? this.entitiesGroupObj.get(type).find((e) => e.id === entity.entity_id)
      : '';
  }

  getNameList(users) {
    if (!users) {
      return '';
    } else {
      let res = '';
      users = users.slice(1);
      users.forEach((value) => {
        const u = this.usersObj.find((e) => e.id === value.responsible_id);
        if (u) {
          res = res + '' + u.userName + '\n';
        }
      });
      return res;
    }
  }

  getUser(user) {
    const u = this.usersObj.find((e) => e.id === user.responsible_id);
    if (u) {
      return u;
    }
    return new User();
  }

  getStyleNoTask() {
    if (this.filteredView) {
      return { height: '100px', 'padding-top': '2%' };
    }
    return { height: '400px', 'padding-top': '12%' };
  }

  getStyleComponent() {
    if (this.filteredView || this.inputTasks) {
      return { 'box-shadow': 'unset', 'border-radius': '0px' };
    }
    return '';
  }

  showComments(event: Event, task): void {
    event.stopPropagation();

    if (!task?.id) return;
    const dialogRef = this.dialog.open(CommentsDialogComponent, {
      data: {
        task_template_id: task.task_template?.id,
        source: 'task',
        transactionId: task.id,
        transactionType: 'TASK',
        height: 55,
      },
      width: '600px',
    });
    dialogRef
      .afterClosed()
      .pipe(take(1))
      .subscribe(({ postedFirstComment }) => {
        if (!postedFirstComment) return;

        this.taskService
          .getTaskV3(task.id)
          .pipe(take(1))
          .subscribe((res1) => {
            if (!res1.data) return;

            const taskStep = res1.data.steps.find((s) => s.id === task.current_step_id);

            if (taskStep.progress !== TaskStatus.PLANNED) return;

            taskStep.progress = TaskStatus.IN_PROGRESS;

            this.taskService
              .updateTaskV3Step(taskStep.id, res1.data)
              .pipe(take(1))
              .subscribe((res2) => {
                if (!res2?.data) return;

                this.loadTasks(this.isCompleted, this.isCanceled);
              });
          });
      });
  }

  private loadTasksCounts(isCompleted, isCanceled) {
    if (this.inputTasks) {
      return;
    }
    if (this.isMyTasks) {
      this.userIdFilter = undefined;
      this.isNotAssigned = false;
      this.userIds = '' + this.user.id;
    }
    if (isCanceled || isCompleted) {
      this.filterStatus = '';
    } else {
      this.filterStatus = this.taskFilterService.filterFormSubject.value.status;
    }
    this.taskService
      .getTasksCounts(
        this.size,
        this.parentId,
        [this.entityIds],
        (this.groupedByTemplate || this.groupedByTeam || this.groupedByTag || this.fromPatient) &&
          this.userIdFilter
          ? this.userIdFilter.id
          : this.userIds,
        this.groupedByTeam ? [this.teamId] : this.categoryId,
        this.filteredView,
        this.EntitiesFilteredBy,
        this.groupedByTemplate ? this.template_id : this.templateIds,
        this.groupedByTag ? this.tagId : this.tagIds,
        this.priority,
        this.toDateCreated,
        this.fromDateCreated,
        this.toDateDue,
        this.fromDateDue,
        this.isFollowing,
        this.isNotAssigned,
        this.search.value,
        this.withFollowup,
        this.filterStatus,
        this.officeId,
      )
      .pipe(take(1))
      .subscribe((res) => {
        this.openTaskLength = res.data.open;
        this.completedTaskLength = res.data.completed;
        this.cancelledTaskLength = res.data.cancelled;
        this.totalCount.emit(this.openTaskLength);
      });
  }

  fetchMyTasks() {
    this.userIdFilter = undefined;
    this.taskFilterService.myTasks.next(!this.isMyTasks);
    if (this.isMyTasks) {
      this.isNotAssigned = false;
      this.userIds = '' + this.user.id;
    } else {
      this.userIds = '';
    }
    this.loadTasks(this.isCompleted, this.isCanceled);
  }

  fetchFollowingTasks() {
    this.isFollowing = !this.isFollowing;
    this.loadTasks(this.isCompleted, this.isCanceled);
  }

  fetchNotAssignedTasks() {
    this.userIdFilter = undefined;
    this.isNotAssigned = !this.isNotAssigned;
    if (this.isNotAssigned) {
      this.taskFilterService.myTasks.next(false);
      this.userIds = '';
    }
    this.loadTasks(this.isCompleted, this.isCanceled);
  }

  resetPagination(type?) {
    this.page = 0;
    this.size = 10;
    this.paginator.pageIndex = 0;
    this.paginator.pageSize = 10;
    this.openedTab = type;
  }

  sortTasks(type, direction = 'asc') {
    this.sortTask = type;
    this.sortDirection = direction ? direction : 'desc';
    this.loadTasks(this.isCompleted, this.isCanceled);
    this.sortSelected = false;
  }

  navigateEntity(type, ent) {
    document.getElementById('kt_entity_details_offcanvas').classList.add('offcanvas-on');
    document.body.setAttribute('data-offcanvas-offcanvas', 'on');
    const overlay = document.getElementById('hide-overlay');
    overlay.removeAttribute('id');
    overlay.setAttribute('id', 'show-overlay');
    this.taskService.newEntity.next({ id: ent.entity_id, type });
  }

  createTask() {
    const dialogConfig = new MatDialogConfig();
    dialogConfig.disableClose = true;
    dialogConfig.closeOnNavigation = true;
    dialogConfig.autoFocus = true;
    dialogConfig.width = '30vw';
    const templateDialog = this.dialog.open(ChooseTemplateDialogComponent, dialogConfig);
    templateDialog
      .afterClosed()
      .pipe(take(1))
      .subscribe((res) => {
        if (!res) {
          return;
        }
        this.loadTasks(this.isCompleted, this.isCanceled);
      });
  }

  openFollowUpDialog(task) {
    if (!task.has_followup) return;

    this.followUpService.openDialog({
      type: 'TASK',
      title: task.current_step_title,
      relatedIds: task.task_entities?.map((e) => e.entity_id) || [],
      body: { id: task.current_step_id },
    });
  }

  unlockTask(task) {
    const dialogRef = this.dialog.open(ConfirmActionDialogComponent, {
      data: {
        title: 'Unlock Card',
        description: 'Are you sure to force unlock this task?',
        waitDescription: 'Unlocking ...',
      },
      width: '440px',
    });
    dialogRef
      .afterClosed()
      .pipe(take(1))
      .subscribe((res1) => {
        if (!res1) return;

        this.taskService
          .updateTaskLock(task.id, { lock: false })
          .pipe(take(1))
          .subscribe((res2) => {
            if (!res2?.ok) return;

            this.locked = false;
            task.lock = true;
            this.layoutUtilsService.showActionNotification(
              'Task successfully Unlocked',
              MessageType.Read,
              3000,
              false,
              false,
            );
            setTimeout(() => {
              this.updateTask(task);
            }, 500);
            this.cdr.detectChanges();
          });
      });
  }

  getBlockersString(blockers: Blocker[]): string {
    let blockersString = '';

    blockers.forEach((blocker) => (blockersString += `${blocker.description}\n`));

    return blockersString;
  }
}

@Component({
  selector: 'kt-update-progress-dialog',
  templateUrl: 'update-progress-dialog.html',
})
export class UpdateProgressComponent {
  constructor(
    public dialogRef: MatDialogRef<UpdateProgressComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
  ) {}

  updateStatus(val: string) {
    this.dialogRef.close(val);
  }
}
